import { ReactNode, useEffect, useRef } from 'react';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';

import {
  ActivitiesComponentType,
  ACTIVITIES_COMPONENT_TYPE_COLUMNS,
} from 'global/constants';
import { MenuItem } from '../components/components-menu/components-menu.constants';

type Props = {
  id: string;
  children: ReactNode;
  type: ActivitiesComponentType;
  menuItem: MenuItem;
};

export const DraggableMenuComponent = ({
  id,
  children,
  type,
  menuItem,
}: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);

  const [{ isDragging }, drag, preview] = useDrag(() => ({
    type,
    item: () => {
      return {
        el: ref.current,
        id,
        isMenu: true,
        menuItem: menuItem,
        isColumnComponent: type === ACTIVITIES_COMPONENT_TYPE_COLUMNS,
      };
    },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
    //eslint-disable-next-line
  }, []);

  drag(ref);
  return (
    <div
      ref={ref}
      style={{
        opacity: isDragging ? 0.4 : 1,
      }}
    >
      {children}
    </div>
  );
};
